import React from 'react';

type Props = {
  open: boolean;
  title?: string;
  hideActionButton?: boolean;
  isActionDisabled?: boolean;
  actionButtonText?: string;
  actionButtonType?: 'Success' | 'Danger';

  hideCancelButton?: boolean;
  cancelButtonText?: string;

  onClose: () => void;
  onCancelClick?: () => void;
  onActionClick?: () => void;

  children: React.ReactNode;
};

const Modal = ({
  open,
  title,
  hideActionButton = false,
  isActionDisabled,
  actionButtonText = 'Ok',
  actionButtonType,

  hideCancelButton = false,
  cancelButtonText = 'Cancel',
  onClose,
  onCancelClick,
  onActionClick,

  children
}: Props) => {
  const ignoreBodyClicks = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <div hidden={!open} className="modal-container">
      <div className="modal-space" onClick={onClose}>
        <div className="custom-modal" onClick={ignoreBodyClicks}>
          <div className="modal-title">
            <h3>{title}</h3>
          </div>

          <div className="modal-contents">{children}</div>

          <div
            className="modal-buttons"
            hidden={hideActionButton && hideCancelButton}
          >
            {!hideActionButton && (
              <button
                onClick={onActionClick}
                disabled={isActionDisabled}
                className={
                  actionButtonType === 'Danger'
                    ? 'danger-button btn'
                    : 'success-button btn'
                }
              >
                {actionButtonText}
              </button>
            )}
            {!hideCancelButton && (
              <button
                onClick={onCancelClick}
                className="cancel-button btn-text-only"
              >
                {cancelButtonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
